
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/fansi-video",
      function () {
        return require("private-next-pages/products/fansi-video/index.tsx");
      }
    ]);
  